const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN as string | undefined;

export function PaymentTestModeBanner() {
  if (!clientToken?.startsWith("pk_test_")) return null;
  return (
    <div className="w-full border-b border-[#C8A84B]/40 bg-[#C8A84B]/15 px-4 py-2 text-center text-xs text-foreground">
      <span className="font-medium">Test mode</span>, payments in the preview are not real. Use card{" "}
      <code className="font-mono">4242 4242 4242 4242</code>.{" "}
      <a
        href="https://docs.lovable.dev/features/payments#test-and-live-environments"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        Learn more
      </a>
    </div>
  );
}